module.exports = __webpack_public_path__ + "img/logo_b.6d395e4d.png";